import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const anchorNavigationButtonInnerFn = /* @__PURE__ */ createRecipe('anchor-navigation-button-inner', {}, [])

const anchorNavigationButtonInnerVariantMap = {}

const anchorNavigationButtonInnerVariantKeys = Object.keys(anchorNavigationButtonInnerVariantMap)

export const anchorNavigationButtonInner = /* @__PURE__ */ Object.assign(memo(anchorNavigationButtonInnerFn.recipeFn), {
  __recipe__: true,
  __name__: 'anchorNavigationButtonInner',
  __getCompoundVariantCss__: anchorNavigationButtonInnerFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: anchorNavigationButtonInnerVariantKeys,
  variantMap: anchorNavigationButtonInnerVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, anchorNavigationButtonInnerVariantKeys)
  },
  getVariantProps: anchorNavigationButtonInnerFn.getVariantProps,
})